import { gql } from '@apollo/client';

export const contractWParentsGql = gql`
  query contractWParents($parkingId: String!, $contractId: String!) {
    contractWParents(parkingId: $parkingId, contractId: $contractId) {
      _id
      name1
      name2
      articleCode
      parent {
        _id

        parent {
          _id
        }
      }
    }
  }
`;
